import React, { FC } from 'react'
import { StarIcon, EmptyStarIcon } from './star_icons'

interface StarRatingProps {
  rating: number
  onChange: (rating: number) => void
  size?: 'md' | 'lg' | 'xl'
  className?: string
}

export const StarRating: FC<StarRatingProps> = ({
  rating,
  onChange,
  size = 'md',
  className = '',
}) => {
  return (
    <div className={`flex justify-start ${className}`}>
      {[1, 2, 3, 4, 5].map((starValue) => (
        <div
          key={starValue}
          className="mr-1 cursor-pointer"
          onClick={() => onChange(starValue)}
        >
          {starValue <= rating ? (
            <StarIcon size={size} color="green" />
          ) : (
            <EmptyStarIcon size={size} color="green" />
          )}
        </div>
      ))}
    </div>
  )
}
